import React, { useMemo } from 'react';
import './AccommodationPage.css';

// placeholder images – put real hotel images in /src/assets/accommodation and update imports
import hotel1 from '../assets/accommodation/hotel1.jpg';
import hotel2 from '../assets/accommodation/hotel2.jpg';
import hotel3 from '../assets/accommodation/hotel3.jpg';
import hotel4 from '../assets/accommodation/hotel4.jpg';
import hotel5 from '../assets/accommodation/hotel5.jpg';
import hotel6 from '../assets/accommodation/hotel6.jpg';
import discountPdf from '../assets/accommodation/Pullman & Mercure King George Square Hotel Offer 2026.pdf';

const hotels = [
  {
    name: 'Emporium Hotel South Bank',
    image: hotel1,
    stars: 5,
    distance: '150m walk',
    website: 'https://www.emporiumhotels.com.au',
    discountWebsite: 'https://reservations.travelclick.com/103264?RatePlanId=10989615',
    description: 'Luxury 5-star accommodation with rooftop infinity pool overlooking the Brisbane River and city skyline.'
  },
    {
    name: 'Pullman & Mercure King George Square Hotel',
    image: hotel4,
    stars: 5,
    distance: '20-min walk',
    website: 'https://www.pullmanbrisbanekgs.com.au',
    discountWebsite: discountPdf,
    description: "Luxury hotel accommodation provides restaurants, bars, corporate meeting rooms and function venues in Brisbane's CBD."
  },
  {
    name: 'Rydges South Bank',
    image: hotel2,
    stars: 4,
    distance: '30m walk',
    website: 'https://www.rydges.com/accommodation/brisbane-qld/brisbane-south-bank/',
    discountWebsite: 'https://www.rydges.com/private-page/international-conference-on-engineering-structures/',
    description: 'Modern 4-star hotel located beside BCEC, featuring river-view rooms and onsite restaurant/bars.'
  },
  {
    name: 'Atlas Apartments',
    image: hotel5,
    stars: 4.5,
    distance: 'Closest to Brisbane Convention & Exhibition Centre',
    website: 'https://www.cllix.com',
    discountWebsite: 'https://elevatebooking.cllix.com/?propertyCode=65db&checkIn=2026-12-01&checkOut=2026-12-04&currency=AUD&adults=2&children=0&promo=ICES2026',
    promoCode: 'ICES2026',
    description: 'With Brisbane Convention & Exhibition Centre and Queensland Performing Arts Complex nearby.'
  },
    {
    name: 'Novotel Brisbane South Bank',
    image: hotel6,
    stars: 4.4,
    distance: '3-min walk',
    website: 'https://www.novotelbrisbanesouthbank.com.au',
    discountWebsite: 'https://all.accor.com/booking/en/accor/hotel/A0X0?dateIn=2026-11-29&compositions=2&stayplus=false&snu=false&accessibleRooms=false&hideWDR=false&productCode=null&hideHotelDetails=true&utm_campaign=hotel_website_search&_gl=1*1wxwrf5*_ga*MTE5ODM1MzA4MS4xNzc0MDcyMzI5*_ga_3LLSBPJBLV*czE3NzQwNzIzMjgkbzEkZzAkdDE3NzQwNzIzMjgkajYwJGwwJGgw&utm_medium=accor_regional_websites&_ga=2.158399615.41326201.1774072329-1198353081.1774072329&utm_source=hotelwebsite_A0X0&dateOut=2026-12-08',
    promoCode: 'NBSBGR',
    description: "Located in the heart of the cultural precinct, near South Bank Parklands, you're perfectly placed to enjoy the wonders of Brisbane and its river city lifestyle."
  },
  {
    name: 'ibis Styles Brisbane Elizabeth Street',
    image: hotel3,
    stars: 4,
    distance: '10-min walk',
    website: 'https://ibisstylesbrisbaneelizabeth.com.au',
    discountWebsite: 'https://ibisstylesbrisbaneelizabeth.com.au/',
    promoCode: 'ISB15',
    description: 'Affordable 3-star option in the CBD close to Queen Street Mall and public transport links.'
  }
];

const AccommodationPage = () => {
  const hotelsWithMeta = useMemo(
    () =>
      hotels.map((hotel) => {
        const discountUrl = hotel.discountWebsite;
        const isDiscountPdf = typeof discountUrl === 'string' && discountUrl.toLowerCase().includes('.pdf');
        return {
          ...hotel,
          discountUrl,
          isDiscountPdf
        };
      }),
    []
  );

  return (
    <section className="accommodation-page fade-in-up">
      <div className="container-small">
        <h1 className="accom-heading">Recommended Accommodation</h1>
        <p className="accom-intro">Below is a curated list of hotels within easy reach of the Brisbane Convention & Exhibition Centre (BCEC), the ICES2026 venue.</p>

        <div className="hotel-grid">
          {hotelsWithMeta.map((hotel) => (
            <div key={hotel.name} className="hotel-card">
              {hotel.image && (
                <div className="hotel-img-wrapper">
                  <img src={hotel.image} alt={hotel.name} className="hotel-img" />
                </div>
              )}
              <div className="hotel-details">
                <h2 className="hotel-name">{hotel.name}</h2>
                <p className="hotel-stars">{'★'.repeat(hotel.stars)}</p>
                <p className="hotel-distance">{hotel.distance} to venue</p>
                <p className="hotel-desc">{hotel.description}</p>
                <div className="hotel-actions">
                  {hotel.discountUrl && (
                    <a href={hotel.discountUrl} target="_blank" rel="noreferrer" className="hotel-link hotel-link-discount">
                      {hotel.isDiscountPdf ? 'Book now with 15% off' : 'Booking via exclusive link with discount'}
                    </a>
                  )}
                  {hotel.promoCode && (
                    <p className="hotel-promo-code">Promo code: <span className="promo-code-value">{hotel.promoCode}</span></p>
                  )}
                  <a href={hotel.website} target="_blank" rel="noreferrer" className="hotel-link">Visit website →</a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AccommodationPage;
